import type { OwnProfileOption } from '@gb-ticket/shared-types';

type ChoiceOption = {
  id: string;
  label: string;
  disabled: boolean;
};

/** Active rows from profile-options, plus the stored inactive choice so it stays visible. */
export function profileChoiceOptions(
  loaded: readonly OwnProfileOption[] | undefined,
  savedId: string | null,
  savedName: string | null,
  savedActive: boolean,
): ChoiceOption[] {
  const choices: ChoiceOption[] = (loaded ?? []).map((item) => ({
    id: item.id,
    label: item.name,
    disabled: false,
  }));
  if (!savedId || choices.some((item) => item.id === savedId)) {
    return choices;
  }
  const inactive = savedActive === false;
  choices.push({
    id: savedId,
    label: inactive ? `${savedName ?? 'Unbekannt'} (inaktiv)` : (savedName ?? 'Ausgewählt'),
    disabled: false,
  });
  return choices;
}
